// extracted by mini-css-extract-plugin
export var footer = "_qz-0";
export var inherit = "_qz-1";
export var input = "_qz-2";
export var modalContent = "_qz-3";
export var quillEditor = "_qz-4";
export var subtitle = "_qz-5";